import Vue from "vue";

Vue.component("wto-user-language-selector", {
	props: [
		"party",
		"language",
		"languages"
	],
	data() {
		return {
			dataLanguages: [],
			dataLanguage: 'en',
			isLoading: false,
			originalLanguages: [],
			defaultLanguages: window.languages
		}
	},
	computed: {
		englishText() {
			return htmlEntity.decode(window.labels.english);
		},
		frenchText() {
			return htmlEntity.decode(window.labels.french);
		},
		spanishText() {
			return htmlEntity.decode(window.labels.spanish);
		},
		originalLanguageText() {
			return htmlEntity.decode(window.labels.originalLanguage);
		}
	},
	methods: {
		getLanguagesByParty: function (party) {
			this.isLoading = true;
			this.$services.partyNotificationLanguages.getLanguagesByPartyId({
				partyId: party,
				language: window.currentLanguage
			})
				.then((data) => {
					
					const dataLanguages = [];
					const notificationLanguages = this.languages;
					var vm = this;

					data.languages.forEach(function (entry) {
						switch (entry) {
							case 1:
								dataLanguages.push({ nativeValue: 'en', text: 'EN', description: vm.englishText, value: entry });
								break;
							case 2:
								dataLanguages.push({ nativeValue: 'fr', text: 'FR', description: vm.frenchText, value: entry });
								break;
							case 3:
								dataLanguages.push({ nativeValue: 'es', text: 'ES', description: vm.spanishText, value: entry });
								break;
						}
					});

					this.isLoading = false;
					this.$emit("update:languages", data.languages);
					this.dataLanguages = dataLanguages;

					//if (notificationLanguages && notificationLanguages.length > 0 && isFilterLanguages) {
					//	this.originalLanguages = notificationLanguages.filter(item => data.languages.includes(item));
					//	this.selectNotificationLanguage();
					//} else {
					//	this.originalLanguages = data.languages;
					//}
					this.originalLanguages = data.languages;

					//this.setDataLanguageVal(data.languages.includes(window.currentOfficialLanguageInt) ? window.currentLanguage : dataLanguages[0].nativeValue);

					//if (!this.skipInitializeVm) {
					//	this.$emit('initialize-original-view-model');
					//}
				});
		},
		selectNotificationLanguage: function () {
			var originalLanguages = this.originalLanguages;
			var selectedLanguages = [];
			var vm = this;
			originalLanguages.forEach(function (v) {
				selectedLanguages.push(vm.dataLanguages.filter(item => item.value == v)[0]);
			})

			selectedLanguages.sort(function (a, b) {
				return a.value - b.value;
			})

			//this.dataLanguage = selectedLanguages[0].nativeValue;
			this.setDataLanguageVal(selectedLanguages[0].nativeValue);
			this.$emit("update:languages", originalLanguages);
		},
		setDataLanguageVal: function (val) {
			this.dataLanguage = val;
			this.$emit("update:language", val);
			//this.$emit("update:notificationLanguage", this.dataLanguages.filter(item => item.nativeValue == val)[0].value);
		},
		changeLanguage: function (event, val) {
			console.log(val);
			this.$emit("update:language", val);

			//this.$emit('change-language', val, event);
		}
	},
	
	mounted() {
		if (this.party) {
			this.getLanguagesByParty(this.party);

		}
	},
	watch: {
		party: function (val) {
			if (val) {
				this.getLanguagesByParty(val);
			} else {
				
				this.setDataLanguageVal("en");
				this.originalLanguages = [];
				this.$emit("update:languages", []);
			}
		},
	},
	template: `
      <div class="columns" v-if="dataLanguages.length > 1">
			<div class="column is-full" style="position: relative">
				<div class="field is-pulled-right" v-if="dataLanguages.length > 1">
					<div class="field-body">
						<div class="field has-addons">
							<label class="mt-1 pr-2 has-text-weight-bold" v-if="dataLanguages.length > 0">{{ originalLanguageText }}</label>
							<b-checkbox 
								:disabled="originalLanguages.length == 1 && originalLanguages[0] == item.value" 
								@input="selectNotificationLanguage" 
								v-model="originalLanguages" 
								:native-value="item.value"
								v-for="(item,index) in dataLanguages" 
								:key="index">
								 {{ item.description }}
							</b-checkbox>
							<b-radio-button 
								v-model="dataLanguage" 
									v-if="originalLanguages.includes(item.value)" 
									:native-value="item.nativeValue" 
									type="is-primary is-light is-outlined" 
									v-for="item in dataLanguages"
												 :key="item.text" 
												 @click.native="changeLanguage($event, item.nativeValue)">
								   {{ item.text }}
								</b-radio-button>
						</div> 
					</div>
				</div>

			</div>
      </div>
	`
});